import { render } from "./recipient-accordion.vue?vue&type=template&id=1da6830e&lang=pug"
import script from "./recipient-accordion.vue?vue&type=script&lang=js"
export * from "./recipient-accordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__